<template>
  <div class="account-card" v-on:click="toggleIncluded(accountNumber)">
    <div class="logo-container">
      <img class="logo-image" :src="require(`@/assets/bank-logos-30/${logoPath}`)">
      <div class="checkbox">
        <div v-if="!isIncluded" class="circle" :class="{ 'checked': isIncluded }"/>
        <img v-else :src="require('@/assets/icons/icon-check-blue.svg')">
      </div>
    </div>
    <div class="account-number">{{ accountNumber }}</div>
    <div class="bank-name">{{ bankDisplayName }}</div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import sourceToLogo from '../../utils/sourcesToLogo';

export default {
  name: 'AccountCard',
  props: {
    sourceName: {
      type: String,
      required: true,
    },
    bankDisplayName: {
      type: String,
      required: true,
    },
    accountNumber: {
      type: String,
      required: false,
    },
    isIncluded: {
      type: Boolean,
      default: true,
    },
    toggleIncluded: {
      type: Function,
      required: true,
    },
  },
  components: {
    Separator: BaseUI.Separator,
    RiseupButton: BaseUI.RiseupButton,
  },
  computed: {
    logoPath() {
      return sourceToLogo[this.sourceName];
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .account-card {
    height: 185px;
    @include responsive-padding;
    margin-bottom: 30px;
    border: solid 1px $riseup_v2_grey;
    border-radius: 10px;
    box-shadow: 0 5px 10px 0 rgba(194, 196, 210, 0.5);
    width: 100%;
    background-color: $riseup-white;

    .logo-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 25px 0 40px;

      .logo-image {
        height: 30px;
      }

      .checkbox {
        display: flex;
        align-items: center;

        .circle {
          display: inline-block;
          height: 32px;
          width: 32px;
          vertical-align: middle;
          text-align: center;
          border-radius: 50%;
          border: 1px solid $riseup_gray_2;
          background-color: $riseup_white;
        }
      }
    }

    .account-number {
      font-size: 28px;
      font-weight: bold;
      font-family: SimplerPro;
      color: $riseup_black;
    }
    .bank-name{
      margin-top: 15px;
      font-size: 14px;
      font-family: SimplerPro;
      color: $riseup_black;
    }
  }
</style>



// WEBPACK FOOTER //
// src/base-components/onboarding/AccountCard.vue